import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { useLanguage } from "../utils/LanguageContext";
import "../Styles/News.scss";

const airtableApiKey = process.env.REACT_APP_AIRTABLE_TOKEN;
const baseId = process.env.REACT_APP_AIRTABLE_BASE_ID;
const tableName = "News";

const News = () => {
  const { language } = useLanguage();
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2;

  function getVisiblePages(current, total, delta = 1) {
    const range = [];
    const rangeWithDots = [];
    let l;

    for (let i = 1; i <= total; i++) {
      if (
        i === 1 ||
        i === total ||
        (i >= current - delta && i <= current + delta)
      ) {
        range.push(i);
      }
    }

    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push("…");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }

    return rangeWithDots;
  }

  // useEffect(() => {
  //   if (!baseId || !airtableApiKey) {
  //     console.error("Missing Airtable environment variables!");
  //     setLoading(false);
  //     setNewsData([]); // fallback to empty array
  //     return;
  //   }

  //   const fetchNews = async () => {
  //     try {
  //       const response = await fetch(
  //         `https://api.airtable.com/v0/${baseId}/${tableName}?sort[0][field]=ID&sort[0][direction]=desc`,
  //         {
  //           headers: { Authorization: `Bearer ${airtableApiKey}` },
  //         }
  //       );
  //       const data = await response.json();
  //       setNewsData(Array.isArray(data.records) ? data.records : []);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching Airtable data:", error);
  //       setLoading(false);
  //       setNewsData([]); // fallback to empty array
  //     }
  //   };

  //   fetchNews();
  // }, []);

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      try {
        const res = await fetch(
          "https://bytechs-api-news.round-sky-5dcc.workers.dev/news"
        );
        const data = await res.json();
        setNewsData(data.records || []);
      } catch (error) {
        console.error("Error fetching news:", error);
        setNewsData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentNewsData = newsData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(newsData.length / itemsPerPage);
  const visiblePages = getVisiblePages(currentPage, totalPages);

  if (loading) {
    return <p>Loading news...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }
  return (
    <section id="news" className="section news">
      <div
        className={`news-container ${
          language === "ar" ? "align-right" : "align-left"
        }`}
      >
        <h2 className="news-title">
          {language === "en" ? "ByTechS News" : "أخبار بايتكس"}
        </h2>

        {/* News List */}
        <div className="carousel">
          <div className="carousel-wrapper">
            {currentNewsData.length > 0 ? (
              currentNewsData.map((record) => {
                const { fields } = record;
                const imageUrl = fields.Image ? fields.Image[0].url : "";

                return (
                  <div key={record.id} className="carousel-slide">
                    <div className="image-container">
                      <a href={fields.Post}>
                        {imageUrl && (
                          <img
                            src={imageUrl}
                            alt={fields.Name}
                            style={{
                              width: "100%",
                              aspectRatio: "16/9",
                              height: "225px",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                        )}
                      </a>
                    </div>
                    <div className="content-container">
                      <span className="event-tag">
                        {language === "en" ? fields.Tag_eng : fields.Tag_ar}
                      </span>
                      <p className="event-title">
                        {language === "en" ? fields.Title_eng : fields.Title_ar}
                      </p>
                      <p className="event-content">
                        {language === "en"
                          ? fields.Content_eng
                          : fields.Content_ar}
                      </p>
                    </div>
                    {/* <p
                      className={
                        language === "ar" ? "event-date-ar" : "event-date-en"
                      }
                    >
                      {fields.Date}
                    </p> */}
                  </div>
                );
              })
            ) : (
              <p>No news available at the moment.</p>
            )}
          </div>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button
            className={`${language === "ar" ? "arrow" : ""}`}
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            <FontAwesomeIcon
              icon={faChevronLeft}
              style={{ color: "#32eddf" }}
            />
          </button>
          {visiblePages.map((number) => (
            <button
              key={number}
              onClick={() => setCurrentPage(number)}
              className={currentPage === number ? "active" : ""}
            >
              {number}
            </button>
          ))}
          <button
            className={`${language === "ar" ? "arrow" : ""}`}
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            <FontAwesomeIcon
              icon={faChevronRight}
              style={{ color: "#32eddf" }}
            />
          </button>
        </div>
      </div>
    </section>
  );
};

export default News;
